export const Action = {
  FETCH_SOUNDS: 'fetchSounds'
}
